import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  closeButtonSx,
  CONFIRM_DIALOG_MAX_WIDTH,
  footerSx,
  headerSx,
  primaryButtonSx,
  secondaryButtonSx,
  subtitleSx,
  titleSx,
} from '../campaigns/applicationNegotiationTheme';
import { getGuestAccessCopy } from '../../utils/auth/guestBrowseIntent';

function GuestBrandAccessDialog({
  open,
  onClose,
  onLogin,
  onSignUp,
  intent = 'browse',
  title,
  message,
  primaryLabel,
  testId = 'guest-brand-access-dialog',
}) {
  const theme = useTheme();
  const copy = getGuestAccessCopy(intent);
  const resolvedTitle = title || copy.title;
  const resolvedMessage = message || copy.message;
  const resolvedPrimaryLabel = primaryLabel || copy.primaryLabel;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      hideBackdrop
      disableScrollLock
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      aria-labelledby="guest-brand-access-title"
      aria-describedby="guest-brand-access-description"
      data-testid={testId}
      sx={{
        pointerEvents: 'none',
        '& .MuiDialog-container': {
          pointerEvents: 'none',
        },
      }}
      PaperProps={{
        sx: {
          pointerEvents: 'auto',
          borderRadius: '16px',
          margin: 2,
          width: '100%',
          maxWidth: CONFIRM_DIALOG_MAX_WIDTH,
          boxShadow: theme.palette.chat?.windowShadow || theme.shadows[8],
        },
      }}
    >
      <Box sx={headerSx}>
        <Box sx={{ minWidth: 0, pr: 1 }}>
          <Typography id="guest-brand-access-title" component="h2" sx={titleSx}>
            {resolvedTitle}
          </Typography>
        </Box>
        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={closeButtonSx}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent sx={{ px: { xs: 2, sm: 3 }, pt: 0, pb: 1 }}>
        <Typography id="guest-brand-access-description" sx={subtitleSx}>
          {resolvedMessage}
        </Typography>
      </DialogContent>

      <DialogActions sx={footerSx(theme)} disableSpacing>
        <Button
          variant="outlined"
          onClick={onLogin}
          sx={{
            ...secondaryButtonSx,
            borderColor: 'divider',
            color: 'text.primary',
          }}
        >
          Log in
        </Button>
        <Button
          variant="contained"
          onClick={onSignUp}
          sx={{
            ...primaryButtonSx(theme),
            bgcolor: 'accent.main',
            color: 'common.white',
            '&:hover': {
              bgcolor: 'favorite.dark',
              boxShadow: 'none',
            },
          }}
        >
          {resolvedPrimaryLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default React.memo(GuestBrandAccessDialog);
